(function () {
    'use strict';

    const tooltipTrigger = document.getElementById('quick-exit-tooltip-trigger');
    const tooltipContent = document.getElementById('quick-exit-tooltip-content');
    const quickExitButton = document.getElementById('quick-exit-button');
    
    // Check if elements exist before adding event listeners
    if (!tooltipTrigger || !tooltipContent || !quickExitButton) {
        return;
    }
    
    // Get the quick exit URL from the button
    const quickExitUrl = quickExitButton.getAttribute('data-quick-exit-url');

    /**
     * Function to toggle tooltip visibility
     */
    function toggleTooltip() {
        const isHidden = tooltipContent.getAttribute('aria-hidden') === 'true';
        
        if (isHidden) {
            // Show tooltip
            tooltipContent.style.display = 'block';
            tooltipContent.setAttribute('aria-hidden', 'false');
            tooltipTrigger.setAttribute('aria-expanded', 'true');
        } else {
            // Hide tooltip
            tooltipContent.style.display = 'none';
            tooltipContent.setAttribute('aria-hidden', 'true');
            tooltipTrigger.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * Function to close the site
     * @param {string} site - The URL to redirect to
     */
    function quickExit(site) {
        // then redirect to a non-sensitive site
        window.open(site, '_blank');
        window.location.replace(site);
        // remove as much info from URL as possible
        if (window.history) {
            try {
                window.history.replaceState({}, '', '/');
            } catch (e) {
                console.error(e);
            }
        }
        // disable default event handling
        return false;
    }

 
    // Event listener for quick exit button
    quickExitButton.addEventListener('click', () => {
        quickExit(quickExitUrl);
    });
    
    // Event listener for esc key - using capture phase for highest priority
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            quickExit(quickExitUrl);
        }
    }, { capture: true });

    // Event listeners for 'what's this' tooltip
    tooltipTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        toggleTooltip();
    });

    tooltipContent.addEventListener('click', (e) => {
        e.preventDefault();
        toggleTooltip();
    });

}());